const PRODUCTS_ROUTES = {
  path: '/products',
  component: () => import('@/pages/Products/ProductPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'products.index',
      component: () => import('@/pages/Products/ProductsPage.vue'),
    },
    {
      path: 'create',
      name: 'products.create',
      component: () => import('@/pages/Products/ProductFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'products.edit',
      component: () => import('@/pages/Products/ProductFormPage.vue'),
    },
  ],
};

export default PRODUCTS_ROUTES;
